/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SuspendedPlayerMatch = {
    properties: {
        team1: {
            type: 'array',
            contains: {
                type: 'SuspendedPlayer',
            },
            isRequired: true,
        },
        team2: {
            type: 'array',
            contains: {
                type: 'SuspendedPlayer',
            },
            isRequired: true,
        },
    },
} as const;
